import React from "react";
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const SummaryTable = ({ data }) => {
  const platformCut = (() => {
    switch (data?.subscriptionPlan) {
      case "Growth Plan":
        return 0.09;
      case "Basic Plan":
        return 0.06;
      default:
        return 0.1;
    }
  })();

  const rows = [];

  // Add subscription entries
  data?.creatorSubscribers?.forEach((entry) => {
    const price = entry.package?.price || 0;
    const platformShare = +(price * platformCut).toFixed(2);
    const creatorShare = +(price - platformShare).toFixed(2);

    rows.push({
      subscriber: `${entry.subscriber?.firstName || ""} ${
        entry.subscriber?.lastName || ""
      }`,
      type: "Subscription",
      title: entry.package?.packageName || "",
      amountPaid: price,
      platformShare,
      creatorShare,
    });
  });

  // Add PPV purchases from posts
  data?.posts?.forEach((postObj) => {
    const post = postObj?.post;
    if (!post || !Array.isArray(postObj?.subscribers)) {
      return;
    }

    const price = post.price || 0;
    const title = post.title || "Untitled";
    const visibility = post.visibility || "";

    postObj.subscribers?.forEach((entry) => {
      const subscriber = entry?.subscriber;
      if (!subscriber) return;

      const platformShare = +(price * platformCut).toFixed(2);
      const creatorShare = +(price - platformShare).toFixed(2);

      rows.push({
        subscriber: `${subscriber.firstName || ""} ${
          subscriber.lastName || ""
        }`,
        type:
          visibility === "payPerViewToEveryone"
            ? "PPV for everyone"
            : "PPV for subscriber",
        title,
        amountPaid: price,
        platformShare,
        creatorShare,
      });
    });
  });

  const totalRevenue = rows.reduce((sum, r) => sum + r.amountPaid, 0);
  const totalCreator = rows.reduce((sum, r) => sum + r.creatorShare, 0);
  const totalPlatform = rows.reduce((sum, r) => sum + r.platformShare, 0);

  return (
    <Box p={3}>
      <Typography variant="h6" gutterBottom>
        Summary of Revenue (Plan: {data?.subscriptionPlan})
      </Typography>
      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Subscriber</strong>
              </TableCell>
              <TableCell>
                <strong>Type</strong>
              </TableCell>
              <TableCell>
                <strong>Title</strong>
              </TableCell>
              <TableCell>
                <strong>Amount Paid</strong>
              </TableCell>
              <TableCell>
                <strong>Creator Share</strong>
              </TableCell>
              <TableCell>
                <strong>Platform Share</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                <TableCell>{row.subscriber}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>${row.amountPaid}</TableCell>
                <TableCell>${row.creatorShare}</TableCell>
                <TableCell>${row.platformShare}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
              <TableCell colSpan={3}>
                <strong>Total</strong>
              </TableCell>
              <TableCell>
                <strong>${totalRevenue.toFixed(2)}</strong>
              </TableCell>
              <TableCell>
                <strong>${totalCreator.toFixed(2)}</strong>
              </TableCell>
              <TableCell>
                <strong>${totalPlatform.toFixed(2)}</strong>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SummaryTable;
